import { useState } from "react"
import { ChevronDown, ChevronRight } from "lucide-react"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/shared/ui/table.tsx"
import { Button } from "@/shared/ui/button.tsx"
import { ExpandedRowContent } from "./ExpandedRowContent"
import { SocialPostTypeWithFeedback } from "../types"

interface ExpandableDataTableProps {
  data: SocialPostTypeWithFeedback[]
}

export default function ExpandableDataTable({
  data,
}: ExpandableDataTableProps) {
  const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set())

  const toggleRow = (id: number) => {
    const newExpandedRows = new Set(expandedRows)
    if (newExpandedRows.has(id)) {
      newExpandedRows.delete(id)
    } else {
      newExpandedRows.add(id)
    }
    setExpandedRows(newExpandedRows)
  }

  return (
    <div className="border w-full rounded-lg">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-12"></TableHead>
            <TableHead className="w-28">ID</TableHead>
            <TableHead>Title</TableHead>
            <TableHead className="w-32">Total</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((row) => (
            <>
              <TableRow key={row.post_id} className="cursor-pointer hover:bg-muted/50" onClick={() => toggleRow(row.post_id)}>
                <TableCell>
                  <Button variant="ghost" size="icon" >
                    {expandedRows.has(row.post_id) ? (
                      <ChevronDown className="h-4 w-4" />
                    ) : (
                      <ChevronRight className="h-4 w-4" />
                    )}
                  </Button>
                </TableCell>
                <TableCell className="font-medium">{row.post_id}</TableCell>
                <TableCell>{row.post_content.slice(0, 80)}...</TableCell>
                <TableCell className="">{row.feedback.length}</TableCell>
              </TableRow>

              {expandedRows.has(row.post_id) && (
                <TableRow>
                  <TableCell colSpan={4} className="p-2">
                    <ExpandedRowContent row={row} />
                  </TableCell>
                </TableRow>
              )}
            </>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
